import * as React from "react";
import { SVGProps } from "react";
const SvgSocialInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.902 8.737c-.764 0-1.359.595-1.359 1.36 0 .763.595 1.358 1.359 1.358s1.359-.595 1.359-1.359-.595-1.359-1.359-1.359ZM20.968 5h-9.853A6.09 6.09 0 0 0 5 11.115v9.768a6.09 6.09 0 0 0 6.115 6.115h9.768a6.09 6.09 0 0 0 6.115-6.115v-9.768C27.083 7.718 24.365 5 20.968 5Zm3.992 15.968c0 2.208-1.784 4.077-4.077 4.077h-9.768c-2.208 0-4.077-1.784-4.077-4.077v-9.853c0-2.208 1.784-3.992 4.077-4.077h9.768c2.208 0 4.077 1.784 4.077 4.077v9.853ZM16.04 10.35a5.69 5.69 0 1 0 0 11.381 5.69 5.69 0 0 0 0-11.381Zm0 9.343a3.625 3.625 0 0 1-3.652-3.653 3.624 3.624 0 0 1 3.652-3.652 3.625 3.625 0 0 1 3.653 3.652 3.625 3.625 0 0 1-3.653 3.653Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialInstagram;
